import { Modal } from '@mantine/core';
import { atom, useAtom } from 'jotai';

const IsShortcutsModalOpenAtom = atom(false);

export const ShortcutsModal = () => {
  const [isShortcutsModalOpen, setIsShortcutsModalOpen] = useAtom(IsShortcutsModalOpenAtom);

  return (
    <Modal
      title="Shortcuts guide"
      opened={isShortcutsModalOpen}
      onClose={() => setIsShortcutsModalOpen(false)}
    >
      Test
    </Modal>
  );
};
